import React from "react";
import "../index.css";
import backgroundUrl from "../../../img/about/crypto-defi-trading-network-gas-fees-included-background.svg";
import backgroundMobileUrl from "../../../img/about/mobile/Mobiile_ColouredBackgrounds_Network.svg";
import Feature3Img from "../../../img/about/crypto-defi-trading-network-gas-included.png";
import { SectionContainer } from "./elements/SectionContainer";
import { FeatureImage as FeatureImageOriginal } from "./elements/FeatureImage";
import styled from "@emotion/styled";
import { SectionDescription } from "./elements/SectionDescription";
import { SectionTitle } from "./elements/SectionTitle";

export interface Feature3Props {
  className?: string;
}

export const Feature3: React.FC<Feature3Props> = () => {
  const TWITTER_LINK =
    "https://twitter.com/bebop_dex/status/1547955758481805314?s=20&t=V6YrkDcKnhjft6Jb8BmbxA";
  return (
    <Section>
      <div className="d-flex flex-column align-items-center" style={{ paddingBottom: "5%" }}>
        <FeatureImage src={Feature3Img} alt="feature-3" />
        <SectionTitle>Trade with all network fees included</SectionTitle>
        <SectionDescription isMarginBottom={true}>
          Benefit from full transparency to the detailed quote breakdown, with all network fees
          included.
        </SectionDescription>
        <div className="d-flex">
          <button
            type="button"
            className="home-btn btn-bebop-outline dark round"
            onClick={() => window.open(TWITTER_LINK, "_blank")?.focus()}
          >
            Learn how it’s done
          </button>
        </div>
      </div>
    </Section>
  );
};

// Sub-components

const Section = styled(SectionContainer)(() => ({
  backgroundImage: `url(${backgroundUrl})`,
  marginTop: "8.7%",
  height: "auto",

  "@media screen and (min-width: 1280px) and (max-width: 1440px)": {
    marginTop: "128px",
    backgroundSize: "100vw",
  },

  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    backgroundSize: "130vw",
    backgroundPositionX: "center",
  },

  "@media screen and (max-width: 390px)": {
    backgroundImage: `url(${backgroundMobileUrl})`,
    margin: "0",
  },
}));

const FeatureImage = styled(FeatureImageOriginal)(() => ({
  width: "34.6%",
  marginTop: "12%",

  "@media screen and (max-width: 576px)": {
    width: "100%",
  },
}));
